import React from 'react'

import { useParams } from 'react-router'

import { Loader } from '@percept/mui'

import { DefaultLayoutComponent, isNewLayoutApp } from './layout'

import { CampaignSetup } from 'components/CampaignSetup'

import { OrgUnitContext, ReportProviderContext } from '@percept/app-components'

import { useActiveOrgEnvironment } from '../components/Organisation'

import { useDocumentTitle } from '@percept/hooks'

import { DefaultOrganisationRedirect } from './Organisation'

import { providerLabelMap, reportProviderV2Map, urlProviderMap } from '@percept/constants'

import { ReportProviderV2, URLReportProvider } from '@percept/types'


const ProviderCampaignSetupScreen = (): JSX.Element => {
  const { activePlatformUnit } = useActiveOrgEnvironment()

  const { provider: urlProvider } = useParams<{ provider: string }>()
  
  const provider = reportProviderV2Map[urlProviderMap[urlProvider as URLReportProvider]]

  useDocumentTitle({
    paths: [
      activePlatformUnit && activePlatformUnit.name,
      'Campaign Setup',
      providerLabelMap[provider],
    ]
  })

  if( !activePlatformUnit ){
    return (
      <DefaultLayoutComponent>
        <Loader preset='fullscreen' />
      </DefaultLayoutComponent>
    )
  }

  return (
    <DefaultLayoutComponent>
      <OrgUnitContext.Provider value={activePlatformUnit}>
        <ReportProviderContext.Provider value={provider as ReportProviderV2}>
          <CampaignSetup />
        </ReportProviderContext.Provider>
      </OrgUnitContext.Provider>
    </DefaultLayoutComponent>
  )
}


export default (
  isNewLayoutApp ?
    ProviderCampaignSetupScreen :
    DefaultOrganisationRedirect // Ensure non-dashboard apps can't navigate to this route
)

